/* eslint-disable eqeqeq */
import {fillReportStringItemId} from "./stat";

/**
 * @desc TBS 环境下下载QB
 */
export default class TBSDownload {
  constructor (tbs, _appDownloadUrl, _appPkgName, url, statFunc) {
    this.tbs = tbs || window.tbs;
    this._appDownloadUrl = _appDownloadUrl || 'https://appchannel.html5.qq.com/directdown?app=qqbrowser&channel=11417';
    this._appPkgName = _appPkgName || 'com.tencent.mtt';
    this._url = url;
    this._statFunc = statFunc;
  }
  _hashFunc (s) {
    if (s == null) {
      s = '';
    }
    let hash = 0;
    if (s.length === 0) {
      return hash;
    }
    for (let i = 0; i < s.length; i++) {
      const char = s.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash &= hash; // Convert to 32bit integer
    }
    return hash;
  }
  getProgress () {
    let totalSize = 0;
    let downloadedSize = 0;
    try {
      totalSize = parseInt(this.tbs.download.getDownloadFileTotalSize({ url: this._appDownloadUrl }));
      downloadedSize = parseInt(this.tbs.download.getDownloadProgress({ url: this._appDownloadUrl }));
    } catch (error) {
      console.log('error', error);
    }
    if (totalSize == 0 || downloadedSize == 0) {
      return 0;
    }
    return Math.round(100 * downloadedSize / totalSize);
  }
  runApp (options = {}) {
    const apkInfo = {
      packagename: options.appPkgName || this._appPkgName,
      url: options.url || this._url,
      PosID: options.PosID || '816971',
      ChannelID: options.ChannelID || 'dsfkk',
      // businessType: 'ug'
    };
    this.tbs.package.runApp(apkInfo);
  }
  startDownload () {
    let reportString = {};
    try {
      let str = '';
      if (this._statFunc) {
        str = this._statFunc()
      }
      const stat20 = fillReportStringItemId(window.ugData && window.ugData.statInfo && window.ugData.statInfo[999] && window.ugData.statInfo[999][0] || '');
      if (stat20) {
        reportString = {
          reportstring: `${stat20}&subpos=${window.subpos || ''}&acttype=10&t=2${str}`,
          reportstring1: `${stat20}&subpos=${window.subpos || ''}&acttype=11&t=2${str}`,
          reportstring2: `${stat20}&subpos=${window.subpos || ''}&acttype=19&t=2${str}`
        }
      }
    }catch (e) {
      console.log('处理ug统计串错误', e);
    }
    const status = this.tbs.download.getDownloadStatus({ url: this._appDownloadUrl });
    if (status === 'TASK_STATUS_CANCELED') {
      console.debug('恢复下载', this._appDownloadUrl);
      this.tbs.download.resumeDownload({ url: this._appDownloadUrl });
    } else if (status !== 'TASK_STATUS_CREATED' && status !== 'TASK_STATUS_STARTED' && status !== 'TASK_STATUS_PROGRESS') {
      console.log('开始下载', {
        url: this._appDownloadUrl,
        filename: `${Math.abs(this._hashFunc(this._appDownloadUrl))}.apk`,
        ...reportString
      })

      try {
        if (this.tbs && this.tbs.ad && this.tbs.ad.reportMsgByURL) {
          this.tbs.ad.reportMsgByURL({
            'appUrl': this._appDownloadUrl,
            'type': '0',
            'reportUrl': reportString.reportstring,
          })
          this.tbs.ad.reportMsgByURL({
            'appUrl': this._appDownloadUrl,
            'type': '1',
            'reportUrl': reportString.reportstring1,
          })
          this.tbs.ad.reportMsgByURL({
            'appUrl': this._appDownloadUrl,
            'type': '2',
            'reportUrl': reportString.reportstring2,
          })
        }
      }catch (e) {
        console.log('添加统计串错误')
      }
      this.tbs.download.startDownload({
        url: this._appDownloadUrl,
        filename: `${Math.abs(this._hashFunc(this._appDownloadUrl))}.apk`,
        ...reportString
      }, (opt) => {
        console.log('dowload opt', opt);
      });
    }
  }
  pauseDownload () {
    return this.tbs.download.pauseDownload({ url: this._appDownloadUrl });
  }
  resumeDownload () {
    return this.tbs.download.resumeDownload({ url: this._appDownloadUrl });
  }
  startInstall () {
    if (this.tbs.download.installApp({ url: this._appDownloadUrl }) != 0) { // 不等于0说明文件可能已经损坏，需要重新下载
      console.log('手动点击触发安装失败：install:fail', this._appDownloadUrl);
    } else {
      // this.listernIsCanRunApp();
      // console.log('手动点击触发安装完成：install:success');
    }
  }
  // 监听是否调起QB
  listernIsCanRunApp () {
    let listernIsCanRunApp = null;
    listernIsCanRunApp = setInterval(() => {
      const newState = this.getState();
      if (newState === 'installed') {
        clearInterval(listernIsCanRunApp);
        this.runApp();
      }
    }, 2000);
  }
  getState () {
    if (this.isInstalled()) {
      return 'installed';
    } else if (this.isDownloading()) {
      return 'downloading';
    } else if (this.isDownloadCanceled()) {
      return 'downloadcanceled';
    } else if (this.isDownloaded()) {
      return 'downloaded';
    } else if (this.isDownloadError()) {
      return 'downloaderror';
    }
    return 'notdownloaded';
  }
  isDownloadError () {
    const status = this.tbs.download.getDownloadStatus({ url: this._appDownloadUrl });
    if (status === 'TASK_STATUS_FAILED' || status === 'TASK_STATUS_TIMEOUT') {
      if (status === 'TASK_STATUS_FAILED') {
        console.log('下载失败：downloadFailed');
      }
      if (status === 'TASK_STATUS_TIMEOUT') {
        console.log('下载超时：downloadTimeOut');
      }
      return true;
    }
    return false;
  }
  isDownloading () {
    const status = this.tbs.download.getDownloadStatus({ url: this._appDownloadUrl });
    if (status === 'TASK_STATUS_CREATED' || status === 'TASK_STATUS_STARTED' || status === 'TASK_STATUS_PROGRESS') {
      return true;
    }
    return false;
  }
  isDownloadCanceled () {
    const status = this.tbs.download.getDownloadStatus({ url: this._appDownloadUrl });
    if (status === 'TASK_STATUS_CANCELED') {
      return true;
    }
    return false;
  }
  isDownloaded () {
    return this.tbs.download.isFileDownloaded({ url: this._appDownloadUrl }) === 'FILE_HAS_DOWNLOADED';
  }
  isInstalled (options = {}) {
    return this.tbs.package.isApkInstalled({ packagename: options.appPkgName || this._appPkgName }) === '1';
  }
}
